import { ActionType } from '../actionTypes';
import { Action } from '../actions/smartFlyerActions';
import { FileDto, FlyerDto, ErrorDto, flyerDtoInitialState } from "../../dtos";


export class SmartFlyerState {

    flyerDto?: FlyerDto;

    uploadLogo?: FileDto;
    hasUploadLogo?: boolean;

    isFlyerHasBeenSaved?: boolean;
    isFlyerHasBeenPublished?: boolean;
    isFlyerHasBeenViewed?: boolean;
    isFlyerDownloadedAsZipFile?: boolean;
    hasFlyerPages?: boolean;

    loading?: boolean;
    error?: ErrorDto | null;

    //
    pageGridDataXLS?: FileDto;
    hasPageGridDataXLS?: boolean;

    promotionListDataXLS?: FileDto;
    hasPromotionListDataXLS?: boolean;
}

class SmartFlyerInitialState extends  SmartFlyerState {
    
    flyerDto = { ...flyerDtoInitialState };

    uploadLogo = { label: '', file: null };
    hasUploadLogo = false;
    
    isFlyerHasBeenSaved = false;
    isFlyerHasBeenPublished = false;
    isFlyerHasBeenViewed = false;
    hasFlyerPages = false;

    loading = false;
    error = null;

    //
    pageGridDataXLS = { label: '', file: null };
    hasPageGridDataXLS = false;

    promotionListDataXLS = { label: '', file: null };
    hasPromotionListDataXLS = false;
}

const initialState = new SmartFlyerInitialState();

const reducer = (state: SmartFlyerState = initialState, action: Action) : SmartFlyerState =>  {
    
    switch(action.type){
        case ActionType.GET_SMART_FLYER_START:
            return { ...state, error: null, loading: true };

        case ActionType.GET_SMART_FLYER_SUCCESS:
            state.uploadLogo!.label = action.payload.flyerDto?.flyImage!;
            action.payload.flyerDto!.deletedFlyerPages = []; 

            return { ...state, error: null, loading: false, ...action.payload };

        case ActionType.GET_SMART_FLYER_ERROR:
            return { ...state, error: action.payload, loading: false };

        case ActionType.GET_SMART_FLYER_COMPLETED:
            return { ...state, error: null, loading: false };

        case ActionType.SMART_FLYER_DATA_CHANGE_EVENT:
            const newState = { ...state, ...action.payload, error: null, loading: false }
            return newState;

        // the default switch case must be included as followed:
        default:
            return state;
    }

}

export default reducer;